//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SessionSpeakerCard from './SessionSpeakerCard.vue';
import SessionDetailSidebar from './SessionDetailSidebar.vue';
import { scheduleEventBus, SCHEDULE_EVENTS } from './scheduleEventBus';
import { formatTime, formatDate } from './scheduleTimeUtils.js';
import { sanitizeHtml } from './sanitizeHtml.js';

export default {
  name: 'SessionDetail',

  components: {
    SessionSpeakerCard,
    SessionDetailSidebar,
  },

  props: {
    swapcardSessionId: {
      type: String,
      required: true,
    },
    parentContentItemCodename: {
      type: String,
      required: true,
    },
    parentPageUrl: {
      type: String,
      required: true,
    },
    scheduleTabCodename: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      session: null,
      loading: false,
      error: null,
    };
  },

  computed: {
    iosDownloadUrl() {
      return this.$root.swapcardAppDownloadUrlIos || '';
    },

    androidDownloadUrl() {
      return this.$root.swapcardAppDownloadUrlAndroid || '';
    },

    creditType() {
      if (!this.session) return '';
      const value = this.session.creditType || '';
      if (!value || value === 'Not for Credit') return '';
      return value;
    },

    hasTags() {
      if (!this.session) return false;
      return (
        this.session.sessionFormat ||
        (this.session.topics && this.session.topics.length) ||
        this.creditType ||
        this.session.preregRequired
      );
    },

    resolvedLoginUrl() {
      const sessionUrl = (this.session && this.session.sessionUrl) || '';
      if (sessionUrl) return sessionUrl;
      const slug = this.$root.eventSlug || '';
      if (!slug) return '#';
      return `https://myevents.tasb.org/login?redirect_url=${encodeURIComponent(`https://myevents.tasb.org/event/${slug}`)}`;
    },

    hasAppConfig() {
      return !!(this.iosDownloadUrl || this.androidDownloadUrl);
    },

    sanitizedDescription() {
      return sanitizeHtml(this.session && this.session.description);
    },
  },

  watch: {
    swapcardSessionId: {
      immediate: true,
      handler(id) {
        if (id) this.fetchSession();
      },
    },
  },

  methods: {
    async fetchSession() {
      this.loading = true;
      this.error = null;
      this.session = null;

      try {
        const url = `/api/v1/swapcard/${encodeURIComponent(this.parentContentItemCodename)}/sessions/${encodeURIComponent(this.swapcardSessionId)}`;
        const response = await fetch(url, { credentials: 'same-origin' });

        if (!response.ok) {
          this.error = `Failed to load session (${response.status}).`;
          return;
        }

        this.session = await response.json();
        this.$emit('session-loaded');
      } catch (err) {
        this.error = 'Failed to load session. Please try again.';
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      if (history.state && history.state.fromListing) {
        history.back();
        return;
      }
      const url = this.scheduleTabCodename
        ? `${this.parentPageUrl}#${this.scheduleTabCodename}`
        : this.parentPageUrl;
      history.replaceState({}, '', url);
      scheduleEventBus.$emit(SCHEDULE_EVENTS.NAVIGATE_LISTING);
    },

    openModal() {
      scheduleEventBus.$emit(SCHEDULE_EVENTS.OPEN_MODAL, { sessionUrl: (this.session && this.session.sessionUrl) || '' });
    },

    formatDate,

    formatTime,

  },
};
